import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background: ${(props) => props.theme.colorSurface1};
  overflow: hidden;
  border-radius: 1rem;
`

export const ContainerHeader = styled.div<{ padding?: boolean }>`
  background: ${(props) => props.theme.colorSurface1};
  border-bottom: 1px solid ${(props) => props.theme.colorDividerDefault};
  border-radius: 0px 16px 0px 0px;
  width: 100%;
  height: 50px;
  display: flex;
  padding: 0 1rem;
  display: flex;
align-items: center;
 ${(props) => props.padding && 'padding:1rem; height:auto;'}
`


export const ContainerContent = styled.div<{ gap?: string }>`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px - 1rem);
  gap: ${(props) => props.gap || '0rem'};
`

export const ContainerOptions = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        height: 100%;
        position: relative;
        aspect-ratio: 1/1;
`
